var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.the_class }, [
    _c("div", { staticClass: "promopopup-top" }, [
      _c("h3", { staticClass: "promopopup__title" }, [
        _vm._v(_vm._s(_vm.title)),
      ]),
      _vm._v(" "),
      _c("button", {
        staticClass: "promopopup__close",
        on: {
          click: function ($event) {
            return _vm.close()
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "promopopup-bottom" }, [
      _c("div", { staticClass: "promopopup-bottom-left" }, [
        _vm.image
          ? _c("img", {
              attrs: { src: _vm.image, alt: _vm.title || "Promotion image" },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "promopopup-bottom-right" }, [
        _vm.content
          ? _c("p", { staticClass: "promopopup__content" }, [
              _vm._v("\n        " + _vm._s(_vm.content) + "\n      "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.details
          ? _c("p", { staticClass: "promopopup__details" }, [
              _vm._v("\n        " + _vm._s(_vm.details) + "\n      "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            on: {
              click: function ($event) {
                return _vm.addToCart()
              },
            },
          },
          [_vm._v("Add to cart")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }